import React from 'react'
import PropTypes from 'prop-types'

import { Pill } from 'components/Pill'

export const AsOfToday = () => {
  return (
    <Pill
      variant="info"
      caption="As of Today"
    />
  )
}

export const Delta = ({ delta }) => {
  return delta >= 0 ? (
    <Pill
      caption={`+${delta.toLocaleString()} in the last 30 days`}
      variant="success"
    />
  ) : (
    <Pill
      caption={`${delta.toLocaleString()} in the last 30 days`}
      variant="warning"
    />
  )
}

Delta.propTypes = {
  delta: PropTypes.number.isRequired,
}
